module.exports = __webpack_public_path__ + "static/media/tv-time.dca1c421.svg";